import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ResolveErrorComponent} from './resolve-error.component';

export const resolveErrorRoutes: Routes = [
  {
    path: 'resolve-error',
    component: ResolveErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(resolveErrorRoutes)],
  exports: [RouterModule]
})
export class ResolveErrorRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/resolve-error/resolve-error-routing.module.ts